import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import CatLinks from './CatLinks';
import Socials from './Socials';
import OutboundLink from '../common/OutboundLink';
import SearchForm from '../Search/SearchForm';
import { segmentTrackEvent } from '../../utils';

const HeaderFixed = ({
  isMobile,
  HeaderLogo,
  HeaderLogoMark,
  HeaderMenuButton,
  standardArticleTracker,
  category=null,
  logoClick,
  page,
  verticalHomepage,
}) => {

  const altHeader = ['self-care', 'beauty', 'wellness', 'food', 'family', 'fashion', 'wowshop'].includes(category);

  return (
    <div className="header-fixed">
      <div className="header-contents">
        {isMobile &&
          <Fragment>
            <div className="header-content-top">
              <div className="header-content-start">
                <>{HeaderLogo}</>
              </div>
              <div className="header-content-end">
                <>{HeaderMenuButton}</>
                <div className="header-divider"/>
                <SearchForm cssClass="social" canCollapse={true} />
              </div>
            </div>
            <div className="header-content-bottom">
              <CatLinks isMobile={isMobile} category={category} />
            </div>
          </Fragment>
        }
        {!isMobile && 
          <Fragment>
          <div className="header-content-top">
            <div className="header-content-start">
              <>{HeaderLogo}</>
            </div>
            <div className="header-content-end">
              <Socials logoClick={logoClick} parent="header" canCollapse={false} standardArticleTracker={standardArticleTracker} verticalHomepage={verticalHomepage}/>
            </div>
          </div>
          <div className="header-content-bottom">
            <div className="header-content-start">
              <>{HeaderMenuButton}</>
              <CatLinks isMobile={isMobile} category={category} />
            </div>
            <div className="header-content-end">
              <a className="header-subscribe" href="/subscribe" onClick={() => segmentTrackEvent('surround_article', {action: 'subscribe', label: 'stickynav'})}>SUBSCRIBE</a>
              <div className="header-divider"/>
              <SearchForm cssClass="social" canCollapse={true} />
            </div>
          </div>
          </Fragment>
        }
      </div>
    </div>
  )
};

HeaderFixed.propTypes = {
  isMobile: PropTypes.bool,
  HeaderLogo: PropTypes.node,
  HeaderMenuButton: PropTypes.node,
};

export default HeaderFixed;
